import type { UseMutationResult } from "@tanstack/react-query";

export interface CrudMutations<TEntity, TInput> {
  create: UseMutationResult<TEntity, unknown, TInput>;
  edit: UseMutationResult<TEntity, unknown, { id: string; input: TInput }>;
}

// PA-025-E (agent-logs/runs/2026-09-09-spec-211-portal/evidence/
// human-resolution-pa-025-e-duplication.json): BenefitsScreen.tsx y
// RewardsScreen.tsx repetían el mismo despacho crear-o-editar según exista
// `id` — solo cambian los callbacks de éxito/error propios de cada pantalla,
// que siguen viviendo en cada archivo. Extracción sin cambio de
// comportamiento.
export function submitCreateOrEdit<TEntity, TInput>(
  id: string | undefined,
  input: TInput,
  mutations: CrudMutations<TEntity, TInput>,
  onSuccess: (entity: TEntity) => void,
  onError?: (error: unknown) => void,
) {
  if (id) {
    mutations.edit.mutate(
      { id, input },
      { onSuccess, ...(onError ? { onError } : {}) },
    );
    return;
  }
  mutations.create.mutate(input, {
    onSuccess,
    ...(onError ? { onError } : {}),
  });
}
